export const COMPANY_NAME               = 'FiveTravel';

export const BACKEND                    = 'https://admin.fivedragons.ma/?api&action=aci';



